import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const EmailOtpButton = ({ mfaToken }) => {
  const [sending, setSending] = useState(false);
  const [sentTo, setSentTo] = useState("");
  const [wait, setWait] = useState(0);

  useEffect(() => {
    if (wait <= 0) return;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/send-email-otp", { mfa_token: mfaToken });
      setSentTo(data.email);
      setWait(60);
      toast.success(`Codice inviato a ${data.email}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-1.5">
      <button type="button" onClick={send} disabled={sending || wait > 0} data-testid="send-email-otp-button"
        className="flex items-center gap-1.5 text-xs text-blue-400 hover:text-blue-300 disabled:text-slate-500 disabled:cursor-not-allowed transition-colors">
        <Mail className="w-3.5 h-3.5" />
        {sending ? "Invio in corso…" : wait > 0 ? `Invia di nuovo tra ${wait}s` : sentTo ? "Invia di nuovo il codice via email" : "Ricevi il codice via email"}
      </button>
      {sentTo && (
        <p className="text-xs text-emerald-400" data-testid="email-otp-sent-message">
          Codice inviato a {sentTo} (valido 10 minuti). Controlla anche la cartella spam.
        </p>
      )}
    </div>
  );
};
